import { createContext } from 'react';

export const AppleMusicPlayerContext = createContext(null);
